import PerformanceComparison from "../components/PerformanceComparison";
import Subscribe from "../components/Subscribe";
import "./Frontpage.css";

const Frontpage = () => {
  return (
    <div className="center">
      <Subscribe />
      <PerformanceComparison />
    </div>
  );
};

export default Frontpage;
